import { inject } from "vue";
import axios from "axios";
import { saveAs } from "file-saver";
import useAuthentication from "@/composition/useAuthentication";
import useStageconfig from "@/composition/useStageconfig";
import i18n from "@/i18n";

export default () => {
  const eventBus = inject("eventBus");
  const { token } = useAuthentication();
  const { config } = useStageconfig();

  // TODO: use newsitem fetch, use newsitem props
  function copyToClipboard(textToCopy: string) {
    const textArea = document.createElement("textArea") as HTMLInputElement;
    const copiedToClipboard = i18n.t("copiedToClipboard");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);

    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange();
      const selection = window.getSelection();

      range.selectNodeContents(textArea);
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }

    document.execCommand("copy");
    document.body.removeChild(textArea);

    if (eventBus) {
      // @ts-ignore
      eventBus.$emit("appMessage", {
        model: true,
        text: copiedToClipboard
      });
    }
  }

  async function download(residref: string) {
    axios
      .get(`/${residref}`, {
        responseType: "blob",
        baseURL: config.value.mediaDownloadURL,
        headers: {
          Authorization: `Bearer ${token.value}`,
          Accept: "image/jpeg"
        }
      })
      .then(response => {
        saveAs(
          new Blob([response.data], { type: "image/jpeg" }),
          `${residref.replace(/\W/g, "-")}.jpeg`
        );
      });
  }

  return {
    copyToClipboard,
    download
  };
};
